import { render, staticRenderFns } from "./GrantDetails.vue?vue&type=template&id=5e9149d5&scoped=true"
import script from "./GrantDetails.vue?vue&type=script&lang=js"
export * from "./GrantDetails.vue?vue&type=script&lang=js"
import style0 from "./GrantDetails.vue?vue&type=style&index=0&id=5e9149d5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e9149d5",
  null
  
)

export default component.exports